import { useState } from "react";
import { bioPattern } from "../constants/constants";
const useValidation = () => {
  const [errors, setErrors] = useState({});
  const handleOnBlurValidation = e => {
    let { name, validity,value } = e.target;
    if (!validity.valid) {
      setErrors(prevError => ({
        ...prevError,
        [name]: {
          type: getErrorType(validity),
        },
      }));
    } else {
      if (name === "postHeldNumber" && !new RegExp(bioPattern).test(value)) {
        setErrors(prevError => ({
          ...prevError,
          [name]: { type: "pattern" }
        }));
      } else {
        if (errors[name]) {
          setErrors(prevError => {
            const { [name]: deletedKey, ...rest } = prevError;
            return rest;
          });
        }
      }
    }
  };

  const getErrorType = error => {
    if (error.valueMissing) {
      return "required";
    } else if (error.typeMismatch) {
      return "type";
    } else if (error.tooShort) {
      return "min";
    } else if (error.patternMismatch) {
      return "pattern";
    } else {
      return "unknown";
    }
  };

  return { handleOnBlurValidation, errors };
};
export default useValidation;
